export enum ProductType {
  Periodics = 1,
  Books = 2,
  Videos = 3,
  Clipping = 5,
  Codes = 6,
  Legislation = 7
}
